<template>
  <a-modal :visible="showDialog" :mask="false"
           :title="isIos==1?'iOS内购系数修正':'渠道无效流量参数修正'"
           @ok="handleOk"
           @cancel="handleCancel()">
    <template slot="footer">
      <a-button key="back" @click="handleCancel" :loading="loading">
        取消
      </a-button>
      <a-button key="submit" type="primary" :loading="loading" @click="handleOk">
        提交
      </a-button>
    </template>
    <a-form >
      <a-form-item v-if="isIos!==1" label="修正渠道" :label-col="{ span: 7 }" :wrapper-col="{ span: 6 }">
        <a-select v-model="channel" style="width: 200px;" placeholder="请选择渠道" @change="changeFilter()">
          <a-select-option value="facebook" key="facebook">facebook</a-select-option>
          <a-select-option value="google" key="google">google</a-select-option>
          <a-select-option value="aps" key="aps">aps</a-select-option>
          <a-select-option value="unity" key="unity">unity</a-select-option>
          <a-select-option value="ironSource" key="ironSource">ironSource</a-select-option>
          <a-select-option value="mintegral" key="mintegral">MTG</a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item v-else label="修正账户" :label-col="{ span: 7 }" :wrapper-col="{ span: 6 }">
        <a-select v-model="channel" style="width: 200px;" placeholder="请选择账户" @change="changeFilter()">
          <a-select-option value="APPLE国内" key="APPLE国内">APPLE国内</a-select-option>
          <a-select-option value="APPLE武汉" key="APPLE武汉">APPLE武汉</a-select-option>
          <a-select-option value="APPLE香港" key="APPLE香港">APPLE香港</a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item label="修正月份" :label-col="{ span: 7 }" :wrapper-col="{ span: 6 }">
        <a-date-picker
          style="width: 200px;"
          v-model="month"
          @change="changeFilter()"
          valueFormat="YYYY-MM-01" />
      </a-form-item>
      <a-form-item v-if="now_ratio" label="当前系数" :label-col="{ span: 7 }" :wrapper-col="{ span: 6 }">
        {{now_ratio}}
      </a-form-item>
      <a-form-item label="修正系数" :label-col="{ span: 7 }" :wrapper-col="{ span: 6 }">
        <a-input-number v-model="ratio" style="width: 200px;" ></a-input-number>
      </a-form-item>
    </a-form>
  </a-modal>
</template>

<script>
import {ChangeCashRatio, GetCashRatio} from "../../../api/v1/cash_api";

export default {
  name: "RatioDialog",
  props:['showDialog','isIos'],
  data(){
    return {
      channel:'',
      month:'',
      ratio:1,
      now_ratio:'',
      loading:false,
    }
  },
  methods:{
    changeFilter(){
      this.now_ratio = ''
      if (!this.channel||!this.month) return
      GetCashRatio({
        is_ios:this.isIos,
        channel:this.channel,
        date:this.month
      }).then(resp => {
        if (resp.code===200){
          this.now_ratio = resp.data
          this.ratio = resp.data
        }
      })
    },
    handleOk(){
      this.loading = true
      ChangeCashRatio({
        is_ios:this.isIos,
        channel:this.channel,
        date:this.month,
        ratio:this.ratio
      }).then(resp => {
        this.loading = false
        if (resp.code===200){
          this.$message.success(resp.msg)
          this.channel = ''
          this.month = ''
          this.ratio = 1
          this.now_ratio = ''
          this.$emit('close-dialog')
        }else{
          this.$message.error(resp.msg)
        }
      })
    },
    handleCancel(){
      this.$emit('close-dialog')
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Business/Dialog/RatioDialog.vue